import { storageService } from "@twiage/core";

import type { ToggleableGlobalOptions } from "../../types/ToggleableGlobalOptions";
import type { ToggleUseFluidLayout } from "../../types/ToggleUseFluidLayout";

export const toggleUseFluidLayout: ToggleUseFluidLayout = ({ state }) => {
  state.toggleableGlobalOptions.useFluidLayout =
    !state.toggleableGlobalOptions.useFluidLayout;

  const toggleableGlobalOptions =
    storageService.getItemAsObject<ToggleableGlobalOptions>(
      "toggleableGlobalOptions",
    );

  if (toggleableGlobalOptions) {
    toggleableGlobalOptions.useFluidLayout =
      state.toggleableGlobalOptions.useFluidLayout;

    storageService.save("toggleableGlobalOptions", toggleableGlobalOptions);
  }
};
